<template>
  <el-dialog
    v-if="isShow"
    title="Edit Carrier Setting"
    :visible.sync="isShow"
    top="5vh"
    :close-on-click-modal="false"
    :fullscreen="isFullscreen"
  >
    <CarrierSettingEditForm
      ref="editForm"
      v-model="carrierSetting"
    />
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="isShow = false">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="updateCarrierSetting()"
      >
        Update
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import CarrierSettingEditForm from '@/components/Application/Manage/Account/CarrierSettingEditForm'
export default {
  components: {
    CarrierSettingEditForm
  },
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isShow: false,
      isFullscreen: false,
      isSaving: false,
      carrierSetting: {}
    }
  },
  methods: {
    updateCarrierSetting () {
      this.$refs.editForm.$refs.carrierSettingForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.carrierSetting.update(builder => {
            builder.context = { resource: 'account', id: this.accountId }
            builder.include = ['carrier']
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.isShow = false
              this.$emit('saved')
            })
        }
      })
    }
  }
}
</script>

<style>

</style>
